import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();
  
  return (
    <button 
      onClick={toggleLanguage}
      className="px-3 py-1 bg-white/10 text-blue-200 rounded-lg hover:bg-white/20 transition-all text-sm"
    >
      {language.toUpperCase()}
    </button>
  );
};

export default LanguageToggle;
